export default __webpack_public_path__ + "static/media/thunder.310cdb2a.gif";